import { Action } from "@ngrx/store";
import { ParsedAuth } from 'core-lib';

export const AUTH_LOGIN = '[AUTH] Auth Login';
export const AUTH_LOGIN_SUCCESS = '[AUTH] Auth Login Success';
export const AUTH_LOGIN_FAIL = '[AUTH] Auth Login Fail';

export const AUTH_LOGOUT = '[AUTH] Auth Logout';

export const AUTH_GET_PROFILE = '[AUTH] Get Profile';
export const AUTH_GET_PROFILE_FAIL = '[AUTH] Get Profile Fail';
export const AUTH_GET_PROFILE_SUCCESS = '[AUTH] Get Profile Success';

export const AUTH_RENEW_TOKEN = '[AUTH] Renew Token';

export const AUTH_SCHEDULER_START = '[AUTH] Rewal Scheduler Start';
export const AUTH_SCHEDULER_END = '[AUTH] Rewal Scheduler End';

export const RESTORE_SESSION = '[AUTH] Restore Auth Session';
export const RESTORE_SESSION_FAIL = '[AUTH] Restore Auth Session Fail';
export const RESTORE_SESSION_SUCCESS = '[AUTH] Restore Auth Session Success';

export const EXPIRE_SESSION_START = '[AUTH] Starting Expiration Timer';
export const EXPIRE_SESSION_END = '[AUTH] Ending Expiration Timer';
export const EXPIRE_CONFIRM = '[AUTH] User confirmed expiration';

export const SET_PENDING = '[AUTH] Set Auth to Pending';

export class SetPending implements Action {
    readonly type = SET_PENDING;
}

export class ExpireConfirm implements Action {
    readonly type = EXPIRE_CONFIRM;
}

export class ExpireSessionStart implements Action {
    readonly type = EXPIRE_SESSION_START;

    /**
     * @param payload Expiration time
     */
    constructor(public payload: number) { }
}

export class ExpireSessionEnd implements Action {
    readonly type = EXPIRE_SESSION_END;
}

export class RestoreSession implements Action {
    readonly type = RESTORE_SESSION;
}

export class RestoreSessionFail implements Action {
    readonly type = RESTORE_SESSION_FAIL;
}

export class RestoreSessionSuccess implements Action {
    readonly type = RESTORE_SESSION_SUCCESS;

    /**
     * 
     * @param payload JWT Token retrieved from local storage.
     */
    constructor(public payload: { accessToken: string, expiresAt: number }) { }
}

export class AuthRenewToken implements Action {
    readonly type = AUTH_RENEW_TOKEN;

    constructor(public payload: string) { }
}

export class AuthSchedulerStart implements Action {
    readonly type = AUTH_SCHEDULER_START;
}

export class AuthSchedulerEnd implements Action {
    readonly type = AUTH_SCHEDULER_END;
}

export class AuthLogin implements Action {
    readonly type = AUTH_LOGIN;

    constructor(public payload: { email: string, password: string }) { }
}

export class AuthLoginSuccess implements Action {
    readonly type = AUTH_LOGIN_SUCCESS;

    /**
     * 
     * @param payload JWT Auth token
     */
    constructor(public payload: ParsedAuth) { }
}

export class AuthLoginFail implements Action {
    readonly type = AUTH_LOGIN_FAIL;

    constructor(public payload: any) { }
}

export class AuthLogout implements Action {
    readonly type = AUTH_LOGOUT;
}

export class AuthGetProfile implements Action {
    readonly type = AUTH_GET_PROFILE;

    constructor(public payload: any) { }
}

export class AuthGetProfileFail implements Action {
    readonly type = AUTH_GET_PROFILE_FAIL;

    constructor(public payload: any) { }
}

export class AuthGetProfileSuccess implements Action {
    readonly type = AUTH_GET_PROFILE_SUCCESS;

    constructor(public payload: any) { }
}

export type AuthAction = AuthLogin | AuthLoginFail | AuthLoginSuccess | AuthGetProfile | AuthGetProfileFail | AuthGetProfileSuccess | AuthLogout | AuthRenewToken | AuthSchedulerStart | AuthSchedulerEnd | RestoreSession | RestoreSessionFail | RestoreSessionSuccess | ExpireSessionStart | ExpireSessionEnd | ExpireConfirm | SetPending;
